const UMLAUTE: Record<string, string> = { Ä: 'AE', Ö: 'OE', Ü: 'UE', ä: 'ae', ö: 'oe', ü: 'ue', ß: 'SS' };

export function kuerzelVorschlag(name: string): string {
  const woerter = name
    .replace(/[ÄÖÜäöüß]/g, (z) => UMLAUTE[z])
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9\s-]/g, '')
    .trim()
    .split(/[\s-]+/)
    .filter(Boolean);
  if (woerter.length === 0) return '';
  if (woerter.length === 1) return woerter[0].slice(0, 3).toUpperCase();
  const initialen = woerter.map((w) => w[0]).join('');
  const kuerzel =
    initialen.length < 3 ? (woerter[0].slice(0, 2) + initialen.slice(1)).slice(0, 4) : initialen.slice(0, 4);
  return kuerzel.toUpperCase();
}
